<script>

	import Logo from './Logo.svelte';
	import Navigation from './Navigation.svelte';

	export let site;

</script>

<header>
	
	<div class="navigation">
		<Navigation filters={site.filters} />
	</div>
	
	<div class="title">
		<Logo title={site.title} />
	</div>

</header>

<style>

	header {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		flex: 1 1 20%;
	}

	.navigation {
		position: sticky;
		top: 0;
		padding: 1rem;
		z-index: 20;
		background-color: var(--background);
	}
	
	.title {
		position: sticky;
		bottom: 0;
		z-index: 10;
		padding: 1rem;
	}

</style>